import '../themes/global.scss';
import '../themes/confirm_hyg.scss';

import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import {
  showMessage,
  confirmJob,
  CONFIRM_JOB_ACTION,
  fetchJob,
  hideMessage,
  FETCH_JOB_ACTION,
  declineCandidate,
  DECLINE_CANDIDATE,
  getAllSkillCategories,
  hidePaymentMissingPopup,
} from '../actions';
import {
  createLoadingSelector,
  createErrorObjectSelector,
} from '../api/selectors';
import CustomSpinner from '../commonComponents/CustomSpinner';
import { Colors } from '../themes/colors';
import {
  renderCounter,
} from './counterJobs/RenderFunc';
import DeclineCandidatePopup from './DeclineCandidatePopup';

import BackButton from '../commonComponents/BackButton';
import CounterShiftPopup from './CounterShiftPopup';
import { extractSkills, isPartialShift } from '../commonComponents/CommonFunctions';
import CandidateInfo from './CandidateInfo';
import Tooltip from './Tooltip';
import { Links } from '../constants';
import { isEmployeeOption, isEmployeeOptionShift } from './WorkerClassification/utils';
import ConfirmPopup from './shared/ConfirmPopup';
import WarningIcon from '../images/icons/Warning';
import Button from '../commonComponents/Button';

const convenienceFeeTooltip = 'GoTu charges a 3.5% convenience fee on Credit Card transactions. If you do not wish to be charged the convenience fee, please update your billing to E-check/ACH.';

class ConfirmHyg extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalIsOpen: false,
      notes_for_temp: props.user.notes_for_temp || '',
      showFee: false,
      declineCandidatePopup: false,
      counterShiftPopup: false,
    };
  }

  componentDidMount() {
    const {
      location, fetchJob, match, job, allSkillCategories, getAllSkillCategories,
    } = this.props;

    const jobId = location.state ? location.state.jobId : match.params.jobId;

    if (jobId !== job?.id) {
      fetchJob({ jobId });
    }

    if (!allSkillCategories || allSkillCategories?.length === 0) {
      getAllSkillCategories();
    }
  }

  checkIfExpired = () => {
    const { job, showMessage } = this.props;

    const jobCreated = new Date(job.job_datetime).getTime();
    const diff_time = jobCreated - new Date().getTime();

    if (diff_time < 0) {
      showMessage({
        title: 'Expired Job',
        message: 'Job has expired. Please repost if needed',
        isError: true,
        route: '/',
      });
    }
  };

  confirmOffer = () => {
    const { job, confirmJob, match } = this.props;
    const { notes_for_temp } = this.state;
    const candidateId = match?.params?.candidateId;
    const currentCounter = job?.multipleCounters?.find(
      (counter) => counter?.candidate?.id === candidateId,
    );

    confirmJob({
      jobId: job.id,
      data: { notes: notes_for_temp },
      counterOfferId: currentCounter?.id,
    });
  };

  declineCandidatePressed = () => {
    this.setState({ declineCandidatePopup: true });
  };

  handleLearnMore = () => {
    window.open(Links.bankPayments);
    this.setState({ showFee: false });
  };

  handleOKClicked = () => {
    this.setState({ showFee: false });
  };

  handleAcceptClicked = () => {
    this.setState({ counterShiftPopup: false });
    this.confirmOffer();
  };

  handleCancelClicked = () => {
    this.setState({ counterShiftPopup: false });
  };

  render() {
    const {
      job, isLoading, declineCandidate, match, allSkillCategories, user, history, isShowPaymentMissingPopup, hidePaymentMissingPopup,
    } = this.props;
    const { showFee, declineCandidatePopup, counterShiftPopup } = this.state;

    const candidateId = match?.params?.candidateId;
    const currentCounter = job?.multipleCounters?.find(
      (counter) => counter?.candidate?.id === candidateId,
    );

    if (isLoading || !job || !job.best_counter) {
      return <CustomSpinner isLoading={isLoading} />;
    }

    const candidate = currentCounter?.candidate;

    const isCounterHours = isPartialShift(currentCounter);

    const amount = isCounterHours ? currentCounter?.payment?.hygienistPay : job.amount;
    const totalAmount = isCounterHours ? currentCounter?.payment?.totalAmount : job.total;
    const tempmeeFee = isCounterHours ? currentCounter?.payment?.tempmeeFee : job.tm_fee;
    const tempmeeFeePercent = isCounterHours
      ? (currentCounter?.payment?.tempmeeFeeRatio * 100).toFixed(1)
      : job.tm_fee_percent;
    const convenienceFee = isCounterHours
      ? currentCounter?.payment?.convenienceFee
      : job.convenience_fee;
    const convenienceFeePercent = isCounterHours
      ? (currentCounter?.payment?.convenienceFeeRatio * 100).toFixed(1)
      : job.convenience_fee_percent.toFixed(1);
    const workingHours = isCounterHours
      ? moment(currentCounter?.end).diff(moment(currentCounter?.begin), 'hours')
      : job.workingHourls;

    const chargeDate = moment(job.job_datetime)
      .subtract(28, 'days')
      .format('MM/DD/YYYY');
    const startDiff = moment(job.job_datetime).diff(moment(), 'days');

    const { allSpecialtySkills } = extractSkills(allSkillCategories, job, candidate);

    return (
      <div
        className="component_container"
        ref={(element) => (this.divRef = element)}
      >
        <div className="floating_container">
          <div
            style={{
              width: '100%',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <div style={{ width: '95%' }}>
              <BackButton />
            </div>

            <h1 className="global_font bold" style={{ color: Colors.neutral_600 }}>
              Confirm Candidate
            </h1>

            {renderCounter(
              job?.rate !== job?.multipleCounters?.find(
                (counter) => counter?.candidate?.id === candidateId,
              )?.candidateRate,
              job?.multipleCounters?.find(
                (counter) => counter?.candidate?.id === candidateId,
              )?.expiration || new Date(),
            )}

            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <div
                style={{
                  display: 'flex',
                  columnGap: 80,
                  justifyContent: 'center',
                  width: '100%',
                  marginTop: 25,
                  marginBottom: 0,
                }}
              >
                <CandidateInfo
                  candidate={candidate}
                  isFavorite={
                    job?.multipleCounters?.find(
                      (counter) => counter?.candidate?.id === candidate?.id,
                    )?.isFavorite
                  }
                />

                <div
                  style={{
                    width: 400,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    rowGap: 10,
                  }}
                >
                  <h1
                    className="global_font bold_font"
                    style={{
                      fontSize: 20,
                      margin: '0px 0px 25px 0px',
                      color: Colors.primary_500,
                      textAlign: 'center',
                    }}
                  >
                    Shift Details
                  </h1>

                  <div
                    style={{ display: 'flex', justifyContent: 'space-between' }}
                  >
                    <p
                      className="global_font bold_font"
                      style={{ margin: 0, color: Colors.neutral_600, fontSize: 16 }}
                    >
                      Office:
                    </p>
                    <p
                      className="global_font"
                      style={{ margin: 0, color: Colors.neutral_500 }}
                    >
                      {job.offer_owner?.office_name}
                    </p>
                  </div>

                  <div
                    style={{ display: 'flex', justifyContent: 'space-between' }}
                  >
                    <p
                      className="global_font bold_font"
                      style={{ margin: 0, color: Colors.neutral_600, fontSize: 16 }}
                    >
                      {job.profession === 'DN' ? 'Shift Procedures:' : 'Preferred Specialty:'}
                    </p>
                    <p
                      className="global_font"
                      style={{
                        margin: 0,
                        color: Colors.neutral_500,
                        fontSize: 18,
                        textTransform: 'capitalize',
                      }}
                    >
                      {allSpecialtySkills
                        .filter((skill) => job?.skills?.some((sp) => sp?.code === skill?.code))
                        .map(({ name }) => name).join(', ') || 'General'}
                    </p>
                  </div>

                  <div
                    style={{ display: 'flex', justifyContent: 'space-between' }}
                  >
                    <p
                      className="global_font bold_font"
                      style={{ margin: 0, color: Colors.neutral_600, fontSize: 16 }}
                    >
                      Date:
                    </p>
                    <p
                      className="global_font"
                      style={{ margin: 0, color: Colors.neutral_500 }}
                    >
                      {job.local_date}
                    </p>
                  </div>

                  <div
                    style={{ display: 'flex', justifyContent: 'space-between' }}
                  >
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <p
                        className="global_font bold_font"
                        style={{
                          margin: 0,
                          color: Colors.neutral_600,
                          fontSize: 16,
                        }}
                      >
                        {isCounterHours ? 'Original Hours:' : 'Hours:'}
                      </p>

                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          backgroundColor: Colors.neutral_300,
                          height: 'min-content',
                          padding: '0px 5px',
                          marginLeft: 8,
                          borderRadius: 50,
                        }}
                      >
                        <p
                          style={{
                            margin: 0,
                            color: Colors.white,
                            fontFamily: 'Nunito',
                            fontSize: 12,
                            fontWeight: 'bold',
                          }}
                        >
                          EST
                        </p>
                      </div>
                    </div>

                    <p
                      className="global_font"
                      style={{ margin: 0, color: Colors.neutral_500, textDecoration: isCounterHours ? 'line-through' : 'none' }}
                    >
                      {`${job.local_start_time} - ${job.local_end_time}`}
                    </p>
                  </div>

                  {
                    isCounterHours && (
                      <div
                        style={{ display: 'flex', justifyContent: 'space-between' }}
                      >
                        <p
                          className="global_font bold_font"
                          style={{ margin: 0, color: Colors.neutral_600, fontSize: 16 }}
                        >
                          Counter Offer (hours):
                        </p>
                        <p
                          className="global_font"
                          style={{ margin: 0, color: Colors.neutral_500, textTransform: 'lowercase' }}
                        >
                          {`${currentCounter?.local_begin} - ${currentCounter?.local_end}`}
                        </p>
                      </div>
                    )
                  }

                  <div
                    style={{ display: 'flex', justifyContent: 'space-between' }}
                  >
                    <p
                      className="global_font bold_font"
                      style={{ margin: 0, color: Colors.neutral_600, fontSize: 16 }}
                    >
                      {job?.rate !== currentCounter?.candidateRate ? 'Original Rate:' : 'Hourly Rate:'}
                    </p>
                    <p
                      className="global_font"
                      style={{
                        margin: 0,
                        color: Colors.neutral_500,
                        textDecoration: job?.rate !== currentCounter?.candidateRate ? 'line-through' : 'none',
                      }}
                    >
                      {`$${job.rate.toFixed(2)}`}
                    </p>
                  </div>

                  {job?.rate !== currentCounter?.candidateRate ? (
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                      <p
                        className="global_font bold_font"
                        style={{ margin: 0, color: Colors.neutral_600, fontSize: 16 }}
                      >
                        Counter Offer:
                      </p>
                      <p
                        className="global_font"
                        style={{ margin: 0, color: Colors.neutral_500 }}
                      >
                        {`$${currentCounter?.candidateRate?.toFixed(2)}`}
                      </p>
                    </div>
                  ) : (
                    <></>
                  )}

                  <div
                    style={{ display: 'flex', justifyContent: 'space-between' }}
                  >
                    <p
                      className="global_font bold_font"
                      style={{ margin: 0, color: Colors.neutral_600, fontSize: 16 }}
                    >
                      Break
                      {job.is_lunch_break_paid ? ' (Paid)' : ' (Unpaid)'}
                      :
                    </p>
                    <p
                      className="global_font"
                      style={{ margin: 0, color: Colors.neutral_500 }}
                    >
                      {job.lunch_final_break_time}
                      {' '}
                      min
                    </p>
                  </div>

                  <div
                    style={{ display: 'flex', justifyContent: 'space-between' }}
                  >
                    <p
                      className="global_font bold_font"
                      style={{ margin: 0, color: Colors.neutral_600, fontSize: 16 }}
                    >
                      {`Professional pay (${workingHours.toFixed(2)} Hours):`}
                    </p>
                    <p
                      className="global_font"
                      style={{ margin: 0, color: Colors.neutral_500 }}
                    >
                      $
                      {amount.toFixed(2)}
                    </p>
                  </div>

                  <div
                    style={{ display: 'flex', justifyContent: 'space-between' }}
                  >
                    {tempmeeFeePercent !== 0 ? (
                      <p
                        className="global_font bold_font"
                        style={{ margin: 0, color: Colors.neutral_600, fontSize: 16 }}
                      >
                        Service Fee (
                        {tempmeeFeePercent}
                        %):
                      </p>
                    ) : (
                      <p
                        className="global_font bold_font"
                        style={{ margin: 0, color: Colors.neutral_600, fontSize: 16 }}
                      >
                        Service Fee:
                      </p>
                    )}

                    <p
                      className="global_font"
                      style={{ margin: 0, color: Colors.neutral_500 }}
                    >
                      {`$${tempmeeFee.toFixed(2)}`}
                    </p>
                  </div>
                  {job.employeeOptionFee !== 0 && isEmployeeOptionShift(job) && (
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                      <p
                        className="global_font bold_font"
                        style={{ margin: 0, color: Colors.neutral_600, fontSize: 16 }}
                      >
                        Employee Option Fee:
                      </p>
                      <p
                        className="global_font"
                        style={{ margin: 0, color: Colors.neutral_500 }}
                      >
                        {job.employeeOptionFee ? `$${job.employeeOptionFee?.toFixed(2)}` : '$--.--'}
                      </p>
                    </div>
                  )}

                  {job.convenience_fee !== 0 ? (
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                      }}
                    >
                      <div style={{ display: 'flex', flexDirection: 'row' }}>
                        <p
                          className="global_font bold_font"
                          style={{ margin: 0, color: Colors.neutral_600, fontSize: 16 }}
                        >
                          Convenience Fee
                          {' '}
                          {`(${convenienceFeePercent || '0'}%)`}
                          :
                        </p>
                        <span
                          style={{
                            marginLeft: '5px',
                            position: 'relative',
                            bottom: '2.5px',
                          }}
                        >
                          <Tooltip content={convenienceFeeTooltip} />
                        </span>
                      </div>
                      <p
                        className="global_font"
                        style={{ margin: 0, color: Colors.neutral_500 }}
                      >
                        {`$${convenienceFee.toFixed(2) || '0'}`}
                      </p>
                    </div>
                  ) : null}

                  {job?.multi_day_booking && startDiff > 28 ? (
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                      <p
                        className="global_font bold_font"
                        style={{ margin: 0, color: Colors.neutral_600, fontSize: 16 }}
                      >
                        Professional pay charge date:
                      </p>
                      <p
                        className="global_font"
                        style={{ margin: 0, color: Colors.neutral_500 }}
                      >
                        {chargeDate}
                      </p>
                    </div>
                  ) : null}

                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                    }}
                  >
                    <p
                      className="global_font bold_font"
                      style={{
                        margin: 0,
                        color: Colors.neutral_600,
                        display: 'flex',
                        alignItems: 'center',
                        columnGap: 5,
                        fontSize: 16,
                      }}
                    >
                      <p style={{ color: Colors.success_500, margin: 0 }}>Total Pay:</p>
                    </p>

                    <p
                      className="global_font bold"
                      style={{ margin: 0, color: Colors.neutral_500 }}
                    >
                      $
                      {totalAmount.toFixed(2)}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div style={{ width: 500, margin: '40px 0px' }}>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  margin: '20px 0px',
                }}
              >
                <h1
                  className="global_font bold_font"
                  style={{ margin: 10, color: Colors.neutral_600 }}
                >
                  Notes for Temp:
                </h1>
                <textarea
                  className="text_notes"
                  style={{
                    borderWidth: 0,
                    borderRadius: 10,
                    backgroundColor: Colors.neutral_50,
                    boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.25) inset',
                    padding: '12px 20px',
                    height: 80,
                  }}
                  placeholder="(ex. Check in at front desk)"
                  value={this.state.notes_for_temp}
                  onChange={(e) => this.setState({ notes_for_temp: e.target.value })}
                />
              </div>

              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  flexDirection: 'row',
                  justifyContent: 'center',
                  margin: '40px 20px',
                }}
              >
                <Button
                  text="Decline"
                  style={{
                    width: 180, backgroundColor: Colors.secondary_500, marginRight: 20,
                  }}
                  onClick={() => this.declineCandidatePressed()}
                />
                <Button
                  text="Confirm"
                  style={{ width: 180, backgroundColor: Colors.primary_500 }}
                  onClick={() => {
                    if (isCounterHours) {
                      this.setState({ counterShiftPopup: true });
                    } else {
                      this.confirmOffer();
                    }
                  }}
                />

              </div>
            </div>
          </div>
        </div>
        {
          counterShiftPopup ? (
            <CounterShiftPopup
              job={job}
              currentCounter={currentCounter}
              acceptBtnPressed={this.handleAcceptClicked}
              cancelBtnPressed={this.handleCancelClicked}
            />
          ) : null
        }
        {
          declineCandidatePopup ? (
            <DeclineCandidatePopup
              declineBtnPressed={(cancellation_reason) => {
                declineCandidate({
                  jobId: job.id,
                  counterOfferId: currentCounter?.id,
                  cancellation_reason,
                });
                this.setState({ declineCandidatePopup: false });
              }}
              goBackPressed={() => this.setState({ declineCandidatePopup: false })}
            />
          ) : (
            <div />
          )
        }
        {
          isShowPaymentMissingPopup ? (
            <ConfirmPopup
              Icon={() => (
                <div style={{ marginBottom: 20 }}>
                  <WarningIcon width={64} height={64} color={Colors.warning_500} />
                </div>
              )}
              title="Payment Method Missing"
              description='Please add your preferred payment method to "Confirm" or "Decline" a candidate.'
              descriptionStyle={{ width: '76%', marginBottom: 50 }}
              leftButtonText="Go Back"
              leftButtonAction={() => hidePaymentMissingPopup()}
              rightButtonText="Add Payment"
              rightButtonAction={() => {
                hidePaymentMissingPopup();
                history.push('/dashboard/payment');
              }}
            />
          ) : null
        }

      </div>
    );
  }
}

const actions = [CONFIRM_JOB_ACTION, FETCH_JOB_ACTION, DECLINE_CANDIDATE];
const loadingSelector = createLoadingSelector(actions);
const errorSelector = createErrorObjectSelector(actions);

const mapStateToProps = (state) => ({
  user: state.user.user,
  error: errorSelector(state),
  job: state.job.job,
  allSkillCategories: state.user.allSkillCategories,
  isLoading: loadingSelector(state),
  isShowPaymentMissingPopup: state.payments.isShowPaymentMissingPopup,
});

export default connect(mapStateToProps, {
  showMessage,
  confirmJob,
  fetchJob,
  getAllSkillCategories,
  hideMessage,
  declineCandidate,
  hidePaymentMissingPopup,
})(ConfirmHyg);
